export default __webpack_public_path__ + "static/media/XEMP-13.af7023e5.jpg";